import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import history from "../../utilities/history";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SetReferenceUrl = () => {

    const query = useQuery();
    const URL = query.get("URL");

    // call appropiate url
    useEffect(() => {
        history.push({
            pathname: URL,
            search: "",
            state: { isRedirectFromNotification: true }
          })
    }, []);

    return (
        <>
        </>
    );
};

export default SetReferenceUrl;
